import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import {
  BaseDialogButton,
  BaseDialogButtonProps
} from '../BaseDialogButton/BaseDialogButton';
import styles from './BaseDialogTextButton.module.css';

export type BaseDialogTextButtonProps = Omit<BaseDialogButtonProps, 'type'> & {
  type: BaseDialogTextButtonType;
};

export enum BaseDialogTextButtonType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export const BaseDialogTextButton: FunctionComponent<BaseDialogTextButtonProps> =
  React.memo((props) => {
    const { children, type, className, ...remainingProps } = prepareProps({
      props
    });

    return (
      <BaseDialogButton
        {...remainingProps}
        className={classes(
          className,
          styles.button,
          buttonTypeToClassName[type]
        )}
      >
        {children}
      </BaseDialogButton>
    );
  });

const buttonTypeToClassName: Record<BaseDialogTextButtonType, string> = {
  [BaseDialogTextButtonType.Primary]: styles.primary,
  [BaseDialogTextButtonType.Secondary]: styles.secondary
};
